import { render } from "./NewsCategories.vue?vue&type=template&id=b413c06e&scoped=true"
import script from "./NewsCategories.vue?vue&type=script&lang=js"
export * from "./NewsCategories.vue?vue&type=script&lang=js"

import "./NewsCategories.vue?vue&type=style&index=0&id=b413c06e&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b413c06e"]])

export default __exports__